import Swal from "sweetalert2"
import AtomsText from "../atoms/AtomsText"

const MoleculesOthersAppsBox = (props) => {
    const openApp = (url) => {
        if(url){
            Swal.fire({
                title: 'Loading...',
                text: 'Let me prepare the site first😁',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading()
                }
            })
              
            setTimeout(() => {
                Swal.close()
                window.open(url, '_blank')
            }, 3000)
        } else {
            Swal.fire({ 
                icon: "error", 
                title: "Opps!...", 
                html: `This app is still in Leo's local dev phase 🥲🙏. Come back soon and see what's new!`,
                confirmButtonText: "Ahhh I see"
            })
        }
    }

    return (
        <div className="btn-apps-mini" onClick={(e) => openApp(props.url)}>
            <AtomsText type='subtitle-second' text={props.name}/>
            <AtomsText type='content' text={props.desc}/>
        </div>
    )
}
  
export default MoleculesOthersAppsBox
